module.exports = __webpack_public_path__ + "static/GT-Super-Text-Bold-Italic-34397194c53fea5c486e66b1b558fd01.woff";